/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as CommonTypes from './common-types'
import * as OrdersTypes from './orders-types'

export const CustomerRole = {
	Developer: 'DEVELOPER',
	Admin: 'ADMIN',
	User: 'USER'
} as const
export type CustomerRoleType = (typeof CustomerRole)[keyof typeof CustomerRole]
export type CustomerFeatures = {
	updateChannel?: 'alpha' | 'beta' | 'stable'
}
export type Customer = {
	uuid: string
	email: string
	firstName: string
	lastName: string
	fullName: string
	ssn: string
	joinedLoyaltyProgram: boolean
	role: CustomerRoleType
	organizationRole: string
	termsAgreedToAt: number | null
	markedForDeletionAt: number | null
	deletionScheduledFor: number | null
	features?: CustomerFeatures
}
export type OrderListItem = {
	uuid: string
	type: OrdersTypes.OrderTypeType
	displayId: string
	completedAt: number
	total: CommonTypes.TaxAmount
	currencyCode: string
	reward?: OrdersTypes.OrderRewardTotal | null
	salesChannel: {
		uuid: string
		name: string
	}
}
export type TaktikalAuthStartRequest = {
	phoneNumber?: string
	ssn?: string
}
export type TaktikalAuthStartResponse = {
	authRequestUuid: string
	verificationCode: string
	pollingInterval: number
}
export const TaktikalAuthPollStatus = {
	Pending: 'PENDING',
	Completed: 'COMPLETED',
	Failed: 'FAILED',
	Cancelled: 'CANCELLED',
	Expired: 'EXPIRED',
	MarkedForDeletion: 'MARKED_FOR_DELETION'
} as const
export type TaktikalAuthPollStatusType = (typeof TaktikalAuthPollStatus)[keyof typeof TaktikalAuthPollStatus]
export type TaktikalAuthPollResponse =
	| {
			status: 'PENDING' | 'FAILED' | 'CANCELLED' | 'EXPIRED'
	  }
	| {
			status: 'COMPLETED' | 'MARKED_FOR_DELETION'
			customer: Customer
			token: string
	  }

export const zCustomerRole = z.enum(['DEVELOPER', 'ADMIN', 'USER'])
export const zCustomerFeatures = z.object({
	updateChannel: z.enum(['alpha', 'beta', 'stable']).optional()
})
export const zCustomer = z.object({
	uuid: z.string(),
	email: z.string(),
	firstName: z.string(),
	lastName: z.string(),
	fullName: z.string(),
	ssn: z.string(),
	joinedLoyaltyProgram: z.boolean(),
	role: zCustomerRole,
	organizationRole: z.string(),
	termsAgreedToAt: z.number().nullable(),
	markedForDeletionAt: z.number().nullable(),
	deletionScheduledFor: z.number().nullable(),
	features: zCustomerFeatures.optional().nullable()
})
export const zOrderListItem = z.object({
	uuid: z.string(),
	type: OrdersTypes.zOrderType,
	displayId: z.string(),
	completedAt: z.number(),
	total: CommonTypes.zTaxAmount,
	currencyCode: z.string(),
	reward: OrdersTypes.zOrderRewardTotal.optional().nullable(),
	salesChannel: z.object({
		uuid: z.string(),
		name: z.string()
	})
})
export const zTaktikalAuthStartRequest = z.object({
	phoneNumber: z.string().optional(),
	ssn: z.string().optional()
})
export const zTaktikalAuthStartResponse = z.object({
	authRequestUuid: z.string(),
	verificationCode: z.string(),
	pollingInterval: z.number()
})
export const zTaktikalAuthPollStatus = z.enum([
	'PENDING',
	'COMPLETED',
	'FAILED',
	'CANCELLED',
	'EXPIRED',
	'MARKED_FOR_DELETION'
])
export const zTaktikalAuthPollResponse = z.union([
	z.object({
		status: z.enum(['PENDING', 'FAILED', 'CANCELLED', 'EXPIRED'])
	}),
	z.object({
		status: z.enum(['COMPLETED', 'MARKED_FOR_DELETION']),
		customer: zCustomer,
		token: z.string()
	})
])
